import AusbomTick16 from '@ausbom/icon/lib/icons/system/Tick16';

export const ArrowUpDown16 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M4.39542 6.54688L7.03814 3.8V12.2L4.39542 9.45312L3 10.8035L7.99269 16L13 10.8035L11.6046 9.45312L8.96186 12.2V3.8L11.6046 6.54688L13 5.19654L7.99269 0L3 5.19654L4.39542 6.54688Z"
        fill="#707070"
      />
    </svg>
  );
};

export const Upload32 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
      <path d="M29.9545 28V30L2.5 30L2.5 28L29.9545 28Z" fill="#8AA9ED" />
      <path
        d="M15.4083 6.91999L15.4083 25.0505H17.4083L17.4083 6.73703L24.1356 13.4648L25.5498 12.0505L16.4992 2.99996L7.44865 12.0505L8.86286 13.4648L15.4083 6.91999Z"
        fill="#2461E5"
      />
    </svg>
  );
};

export const Cross24 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
        fill="#2461E5"
      />
    </svg>
  );
};

export const Error32 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path d="M17 18V9L15 9V18H17Z" fill="#E61E36" />
      <path
        d="M16 20C16.8284 20 17.5 20.6716 17.5 21.5C17.5 22.3284 16.8284 23 16 23C15.1716 23 14.5 22.3284 14.5 21.5C14.5 20.6716 15.1716 20 16 20Z"
        fill="#E61E36"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16ZM4 16C4 22.6274 9.37258 28 16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16Z"
        fill="#E61E36"
      />
    </svg>
  );
};

export const Error16 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M7 4H9V9H7V4Z" fill="#E61E36" />
      <path
        d="M9 11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10C8.55228 10 9 10.4477 9 11Z"
        fill="#E61E36"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8Z"
        fill="#E61E36"
      />
    </svg>
  );
};

export const Tick16 = ({ primaryColor = '#00A087' }: { primaryColor?: string }) => {
  return <AusbomTick16 primaryColor={primaryColor} />;
};

export const Clock16 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M7 9V4H9V7H12V9H7Z" fill="#949494" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 12.4 12.4 16 8 16C3.6 16 0 12.4 0 8ZM2 8C2 11.3 4.7 14 8 14C11.3 14 14 11.3 14 8C14 4.7 11.3 2 8 2C4.7 2 2 4.7 2 8Z"
        fill="#949494"
      />
    </svg>
  );
};
export const DataCircle16 = ({ primaryColor = '#00A087' }: { primaryColor?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="7" fill={primaryColor} />
    </svg>
  );
};
export const DirectionNone16 = ({ primaryColor = '#707070' }: { primaryColor?: string }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM8 12C5.79086 12 4 10.2091 4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8C12 10.2091 10.2091 12 8 12Z"
        fill={primaryColor}
      />
    </svg>
  );
};

export const Copy16 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M0 0H12V12H0V0ZM2 2V10H10V2H2Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4H16V6H12V4ZM4 14H16V16H4V14ZM4 12H6V14H4V12ZM14 6H16V14H14V6Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Close24 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
        fill="#1E1E1E"
      />
    </svg>
  );
};

export const Menu24 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M1 4H23V6H1V4Z" fill="white" />
      <path d="M1 11H23V13H1V11Z" fill="white" />
      <path d="M23 18H1V20H23V18Z" fill="white" />
    </svg>
  );
};

export const ExternalLink12 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" role="img" aria-hidden="true">
      <path d="M2 0H0V12H12V10H2V0Z" fill="#8AA9ED" />
      <path d="M5.99998 0H12V6H9.99998V3.29289L5.29288 8L3.87866 6.58579L8.46445 2H5.99998V0Z" fill="currentColor" />
    </svg>
  );
};

export const ExternalLink16 = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 0H0V16H16V14H2V0Z" fill="#8AA9ED" />
      <path
        d="M7.00006 0H16.0001V9H14.0001V3.41421L6.58584 10.8284L5.17163 9.41421L12.5858 2H7.00006V0Z"
        fill="currentColor"
      />
    </svg>
  );
};
